// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';
import { Tooltip } from './tooltip';
import { emptyFn, render, createElement } from './common';

/**
 * @class Jsw.SplitButton
 * @extends Jsw.Component
 */
export const SplitButton = Class.create(Component, {
    _initConfiguration($super, config) {
        config = Object.extend({
            cls: 'btn-group',
        }, config || {});
        $super(config);

        this.title = this._getConfigParam('title', '');
        this.isAction = this._getConfigParam('isAction', false);
        this.isDefault = this._getConfigParam('isDefault', false);
        this.isMenuFlip = this._getConfigParam('isMenuFlip', false);
        this.onclick = this._getConfigParam('onclick', emptyFn);
        this.items = this._getConfigParam('items', []);
        this.isScrollable = this._getConfigParam('isScrollable');
    },

    _initComponentElement($super) {
        $super();

        render(this._componentElement, [
            createElement(`button.btn${this.isAction ? '.btn-primary' : ''}`,
                {
                    type: this.isDefault ? 'submit' : 'button',
                    onclick: this.onclick,
                },
                this.title.escapeHTML()
            ),
            createElement('button.btn.dropdown-toggle',
                {
                    type: 'button',
                    onclick: this.openDropdown.bind(this),
                },
                createElement('em.caret')
            ),
            createElement(`ul.dropdown-menu${this.isMenuFlip ? '.dropdown-menu-flip' : ''}${this.isScrollable ? '.dropdown-scrollable' : ''}`),
        ]);

        if (Object.isArray(this.items)) {
            this._initItems();
        }
    },

    _initItems() {
        this.items.each(function (item) {
            const link = new Element('a', {
                id: item.id || null,
                href: item.href || null,
                target: item.newWindow ? '_blank' : null,
            }).update(item.title.escapeHTML());

            const listItem = new Element('li', {
                class: (item.submenu ? 'dropdown-submenu' : '') + (this.isMenuFlip ? ' to-left' : ''),
            }).insert(link);

            if (item.submenu) {
                listItem.insert('<ul class="dropdown-menu"></ul>');
            }

            this._componentElement.down('.dropdown-menu').insert(listItem);

            link.observe('click', item.onclick || emptyFn);

            if (item.tooltip) {
                Tooltip.init(link, { text: item.tooltip });
            }
        }, this);
    },

    _addTooltips() {
        const description = this._getConfigParam('description');
        if (description) {
            this._tooltip = Tooltip.init(this._componentElement.down('button'), { text: description });
        }
    },

    openDropdown(event) {
        Event.stop(event);

        if (Object.isFunction(this.items)) {
            const dropdownMenu = this._componentElement.down('.dropdown-menu');
            dropdownMenu.update(`<div class="ajax-loading">${this.lmsg('loading')}</div>`);

            const { items } = this;
            this.items = [];

            items().then(function (items) {
                dropdownMenu.update('');
                this.items = items;
                this._initItems();
            }.bind(this));
        }

        if (!this._componentElement.hasClassName('open')) {
            $$('.btn-group').each(function (item) {
                item.removeClassName('open');
            });
        }
        this._componentElement.toggleClassName('open');
    },

    _addEvents() {
        const context = this;

        const openSubmenu = function (menuItem) {
            const submenu = menuItem.select('.dropdown-menu').first();
            if (!menuItem.hasClassName('open') && 'undefined' !== typeof submenu && submenu.empty()) {
                context.items.last().submenu ? context.items.last().submenu(menuItem.down('a').next('ul')) : '';
            }
            closeSubmenu(menuItem);
            menuItem.addClassName('open');
            clearTimeout(menuItem._menuTimeout);
        };

        const closeSubmenu = function (menuItem) {
            menuItem.removeClassName('open');
            clearTimeout(menuItem._menuTimeout);
        };

        this._componentElement.select('.dropdown-menu > li').invoke('observe', 'mouseover', function () {
            if (this.hasClassName('dropdown-submenu open')) {
                return;
            }
            this.siblings('.dropdown-submenu.open').each(function (menuItem) {
                closeSubmenu(menuItem);
            });
        });

        const submenu = this._componentElement.select('.dropdown-submenu');
        submenu.invoke('observe', 'mouseover', function (e) {
            openSubmenu(this);
        });
        submenu.each(function (item) {
            item.down('a').observe('touchend', function (e) {
                if (item.hasClassName('open')) {
                    closeSubmenu(item);
                } else {
                    openSubmenu(item);
                }
            }).observe('click', function (e) {
                Event.stop(e);
            });
        });

        this._componentElement.select('.dropdown-submenu').invoke('observe', 'mouseleave', function () {
            const menuItem = this;
            clearTimeout(menuItem._menuTimeout);
            menuItem._menuTimeout = setTimeout(function () {
                closeSubmenu(menuItem);
            }, 500);
        });

        $(document.body).observe('click', function () {
            this._componentElement.removeClassName('open');
        }.bind(this));
    },

    disable() {
        this._componentElement.down('button').disable().addClassName('disabled');
        this._componentElement.down('.dropdown-toggle').disable().addClassName('disabled');
        if (Tooltip.current === this._tooltip) {
            Tooltip.hide();
        }
    },

    enable() {
        this._componentElement.down('button').enable().removeClassName('disabled');
        this._componentElement.down('.dropdown-toggle').enable().removeClassName('disabled');
    },

    setText(text) {
        this._componentElement.down('button').update(text);
    },
});



// WEBPACK FOOTER //
// ./jsw/split-button.js